import React from 'react';
import { T, fonts, layout } from '../../theme/tokens';

export function Eyebrow({ children, color }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        fontFamily: fonts.body,
        fontSize: "0.8rem",
        fontWeight: 600,
        letterSpacing: "3px",
        textTransform: "uppercase",
        color: color || T.accent,
        marginBottom: 14,
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: layout.kickerRule,
          height: "1.5px",
          background: color || T.accent,
        }}
      />
      {children}
    </div>
  );
}
